import * as React from 'react'
import { User } from '../types/types'
import { assertNever } from '../utils'

export interface Props {
  readonly user: User
  readonly onFormSubmit: (event: React.FormEvent<HTMLFormElement>) => void
}

function LoginForm({ user, onFormSubmit }: Props): JSX.Element {
  switch (user.type) {
    case 'FailedToLogout':
    case 'LoggedIn':
      return <div>You are already logged in</div>
    case 'NotLoggedIn':
      return getLoginForm(false, false, onFormSubmit)
    case 'FailedToLogIn':
      return getLoginForm(false, true, onFormSubmit)
    case 'LoggingIn':
      return getLoginForm(true, false, onFormSubmit)
    default:
      return assertNever(user)
  }
}

function getLoginForm(
  formDisabled: boolean,
  displayErrorMessage: boolean,
  onFormSubmit: (event: React.FormEvent<HTMLFormElement>) => void,
): JSX.Element {
  return (
    <>
      {displayErrorMessage ? <div>Login failed. Please try again.</div> : <></>}
      <form
        onSubmit={onFormSubmit}
        className='theme--primary inline-block form-flex'
      >
        <input
          id='username'
          type='text'
          placeholder='Username'
          name='username'
          className='input'
          autoFocus={true}
          required={true}
          disabled={formDisabled}
          autoComplete='username'
        />
        <input
          id='password'
          type='password'
          className='input'
          placeholder='Password'
          required={true}
          disabled={formDisabled}
          autoComplete='password-current'
        />
        <button
          type='submit'
          className='button button--full_width'
          disabled={formDisabled}
        >
          Login
        </button>
      </form>
    </>
  )
}

export default LoginForm
